import { classNames } from '../utils/UNSAFE_classNames';
import { cssProps } from '@oracle/oraclejet-cssprops';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';

const rootStyles = {
  base: cssProps`${{
    verticalAlign: 'top'
  }}`,

  labelInside: cssProps`${{
    maxWidth: '100%'
  }}`
};

export const getFormControlClasses = (hasInsideLabel?: boolean) => {
  return classNames([rootStyles.base, hasInsideLabel && rootStyles.labelInside]);
};

export const getLoadingAriaLabel = () => {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  return translations.formControl_loading();
};
